import type { HouseholdMember, UserId } from '@hewey/shared'
import { colorFor } from '@utils/colors.ts'
import { initialFor } from '@utils/members.ts'
import styles from './AssigneeChips.module.css'

type Props = {
	members: Map<UserId, HouseholdMember>
	ids: UserId[]
	max?: number
}

// Overlapping initial avatars for a task's assignees. Resolves ids against the
// household member map; ids with no match (e.g. a removed member) are skipped.
export const AssigneeChips = ({ members, ids, max = 3 }: Props) => {
	const resolved = ids
		.map((id) => members.get(id))
		.filter((m): m is HouseholdMember => m !== undefined)
	if (resolved.length === 0) return null

	const shown = resolved.slice(0, max)
	const extra = resolved.length - shown.length

	return (
		<span className={styles.chips}>
			{shown.map((m) => (
				<span
					key={m.id}
					className={styles.avatar}
					style={{ background: colorFor(m.id) }}
					title={m.displayName ?? undefined}
				>
					{initialFor(m)}
				</span>
			))}
			{extra > 0 && <span className={styles.more}>+{extra}</span>}
		</span>
	)
}
